import { useState, useEffect, useContext, useRef } from "react";
import { Census_func } from "../../../api/devices/census/census_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Label, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, Subtitle1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Image, Card, InfoLabel, ButtonProps, Tooltip, Link, Textarea, Spinner, Body1Stronger, Body2, Subtitle2 } from "@fluentui/react-components";
import { Info20Regular, Open20Regular, GroupList20Regular, TrayItemRemove20Filled, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize20Regular, Dismiss16Regular, DismissSquare24Filled, FilterAdd20Filled, Info20Filled, Info16Filled } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { GlobalContext } from '../../../hooks/globalContext';
import { ToastComponent } from "../../../components/toast/toast.component";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, secondaryIcon, overflowDivider, buttonContent, dividerWidthStyle, DynamicBoxingCSS, parentHome, wraperStyle, timezoneInfo, SubSectionResponsive, BreadcrumbsBorder, dashboardTheme, oveyAlignment } from "../../../styles/customStyles";
import { FileDownloadComponent } from "../../../components/fileExport/file.export.component";
import FileUploadComponent from "../../../components/fileImport/file.import.component";
import { CensusData, CheckboxState } from "../../../interfaces/devices/census_interface";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat, getExportedData } from "../../../utility/utils";
import DialogBox from "../../../components/dialog/dialog.component";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import ManageView from "../../../components/manage_view/manageView.component";
import * as XLSX from 'xlsx';
import { DynamicDialog } from "../../../components/dialog/dynamic.dialog.component";
import { RadioGroups } from "../../../components/radio_group/radioGroup.component";
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { Inputs } from "../../../components/textarea/input.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { CustomWidgets } from "../../../components/form-components";
import { DevicesPages } from "../../../components/side_menu/InlineSidenav";

const handleExportCSV = () => {
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const Census = () => {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  var tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState<CensusData[] | null>(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPageNo, setCurrentPageNo] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData]: any = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [dropDownValue, setDropDownValue] = useState<any>('');
  const [isfilter, setIsFilter] = useState(false);
  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [machineStatus, setMachineStatus]: any = useState({});
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [overLayData, setOverLayData] = useState<any>({});
  const [selectedValue, setSelectedValue] = useState(0);
  const [deviceSearchVal, setDeviceSearchVal] = useState("");
  const [devicesTableData, setDevicesTableData] = useState([]);
  const [downloadFileDeviceList, setDownloadFileDeviceList] = useState<any>(['"Machines"']);
  const [csvDevicesList, setCsvDevicesList] = useState<any>([]);
  const [devicesOfTenant, setDevicesOfTenant]: any = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [isExpungeMachineData, setIsExpungeMachineData] = useState<boolean>(false);
  const [deleteDevices, setDeleteDevices] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState<any>([]);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [dartTemplatesList, setDartTemplatesList] = useState<any>([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [jsonSchema, setJsonData]: any = useState({
    schema1: {},
    schema2: {}
  });
  // const [jsonSchema2, setJsonData2]: any = useState({});
  const [uiSchema, setUiData]: any = useState({
    schema1: {},
    schema2: {}
  });
  const dartNo: number = 0;
  const [isChecked, setChecked] = useState<CheckboxState>({
    expungeAsset: true,
    expungeEvent: true,
    expungePatch: true
  });
  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [uniqueOS, setUniqueOS] = useState([]);
  const [isuniqueStatus, setUniqueStatus] = useState([]);
  const [uniqueVersion, setUniqueVersion] = useState<string[]>([]);

  const [isOsName, setOsName] = useState([]);
  const [isStatus, setStatus] = useState([]);
  const [versionOptions, setVersionOptions] = useState<any[]>([]);

  const [expungeType, setExpungeType] = useState<string | null>(null);
  const [errorToast, setErrorToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [errorMessage, setErrorMessage] = useState<String>('');
  const [onlineDevices, setOnlineDevices] = useState([]);
  const [offlineDevices, setOfflineDevices] = useState([]);
  const [deviceStatus, setDeviceStatus] = useState("");
  const [dropdownDatas, setDropdownDatas] = useState(null);
  const [overlayType, setOverlayType] = useState("default");
  const [formData1, setFormData1]: any = useState({
    jsonData: ''
  });
  const [formData2, setFormData2]: any = useState({
    jsonData: ''
  });
  const [operationType, setOperationType] = useState({dart61: 'add', dart253: 'add'});

  // EXPORT FUNCTIONALITY
  const [exportOpen, setExportOpen] = useState('');
  // EXPORT REPORT FUNCTION
  const exportReportHandler = () => {
    setExportBtnClicked(true);
  }


  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      tempExportData.push({
        'Tenant Name': tenantName,
        'Machine Name': val.host,
        'Manufacturer': val.value != null && val.value?.length > 0 ? JSON.parse(val.value).chassismanufacturer : "-",
        'Machine Operating Sytem': val.os != undefined ? val.os : "-",
        'Nanoheal Client Version': val.clientversion,
        'Nanoheal Client installed date': convertToExcelFormat(val.born),
        'Nanoheal client\'s Last event': convertToExcelFormat(val.last)
      });
    });

    setExportData(tempExportData);

  }, [exportDetails]);

  useEffect(() => {
    var dropDownDataObj = dartTemplatesList?.map((val: any, i: any) => { return { key: `op_${i + 1}`, label: <Body1 onClick={() => { setSelectedValue(parseInt(val.dartNo)); contextValue.setDartNo(val.dartNo) }}> {val.templateName} </Body1> } });
    setDropdownDatas(dropDownDataObj);

  }, [dartTemplatesList]);

  let exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${tenantName}${dateFormat()}.xlsx`);
  };

  useEffect(() => {
    if (exportOpen) {
      if (exportOpen === 'csv') {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
      }

      if (exportOpen === 'xlsx') {
        exportToExcel()
      }
    }
  }, [exportData])

  // EXPORT CSV FILE DATE AND TIME ADDED TO FILENAME
  const dateFormat = () => {
    const presentDate = new Date();
    const dateform = presentDate.toLocaleDateString();

    const options: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, // Use 24-hour format
    };

    const formattedDate = presentDate.toLocaleString('en-US', options)

    return `_d${dateform}_t${formattedDate}`;
  };


  const radioData = {
    "Export as CSV": "csv",
    "Export as XLSX": "xlsx"
  };

  const handleOptionChange = (value: any) => {
    var optionValue = value.target.value;
    setExportOpen(optionValue);
  }

  const dialogContentBody = () => {
    return <Stack tokens={{ childrenGap: '20' }} verticalFill>
      <Stack horizontal tokens={{ childrenGap: '5' }}>
        <Info20Filled {...primaryIcon} />
        <Text>Select your preferred format for data export.</Text>
      </Stack>
      <Stack verticalFill >
        {/* <CheckBox checked={exportOpen === 'csv'} onChange={() => { onChangeHandler("csv") }} label="Export as csv" />
        <CheckBox checked={exportOpen === 'xlsx'} onChange={() => { onChangeHandler("xlsx") }} label="Export as xlsx" /> */}
        <RadioGroups data={radioData} layout="vertical" value={exportOpen} onChange={(e) => handleOptionChange(e)} required={true} />
      </Stack>
    </Stack>
  }



  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;

    setChecked(prevState => ({
      ...prevState,
      [name]: checked
    }));
  };

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    let result = '';

    if (value1 === 'Device Status') {

      if (value2 === 'Online') {
        setDeviceStatus('Online');
        const subArr = onlineDevices.slice(((currentPageNo - 1) * 50), ((50 * currentPageNo) - 1));
        result = value1 + " : " + subArr.join(",");

        setTotalRecords(onlineDevices.length);
        setTotalPages(Math.ceil(onlineDevices.length / 50));
      } else {
        setDeviceStatus('Offline');
        const subArr = offlineDevices.slice(((currentPageNo - 1) * 50), ((50 * currentPageNo) - 1));
        result = value1 + " : " + subArr.join(",");

        setTotalRecords(offlineDevices.length);
        setTotalPages(Math.ceil(offlineDevices.length / 50));
      }
    } else {
      result = value1 + " : " + value2;
    }

    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  const handleOverlayFilter = (): any => {
    const value1 = dropDownValue1Overlay;
    const value2 = dropDownValue2Overlay;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result]);
    setIsFilter(true);
    setIsOverlayFilter(true);
    // setLoading(true);
    setDropDownValue1Overlay('');
    setDropDownValue2Overlay('');
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1Overlay} :`))) {
      setErrorMessage(`${dropDownValue1Overlay} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
  }

  const handleFilterValueSelect = (event: { target: { value: Event; }; }): void => {
    alert(event.target.value);
  }

  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    !isOverlayFilter && setLoading(true);

    setIsOverlayFilter(false);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    }
    else {
      setResetDisabled(true)
    }
  }, [filterArray])

  useEffect(() => {
    setOsName(uniqueOS?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setStatus(isuniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setVersionOptions(uniqueVersion?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
  }, [uniqueOS, isuniqueStatus, uniqueVersion]);

  useEffect(() => {
    dropDownValue1 === "Choose devices manually" && setSelectedValue(1);
    dropDownValue1 === "Upload a CSV containing the Devices" && setSelectedValue(2);
  }, [dropDownValue1]);

  const handle = useFullScreenHandle();

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9.]*$/;
    // const regexN = /^\d{1,3}(?:\.\d{3})*(?:\.\d+)?$/;
    if (filterArray.some((filter) => filter.startsWith(`${dropDownValue1} :`))) {
      setErrorMessage(`${dropDownValue1} is already filtered.`);
      return;
    } else {
      setErrorMessage(''); // Clear the message if no issue
    }
    if (name === 'filter' && dropDownValue1 === ("Device Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Nanoheal Version")) {
    //   if (regexN.test(enteredValue)) {
    //     setDropDownValue2(enteredValue);
    //   }
    // }
    if (name === 'filter' && dropDownValue1 === ("Manufacturer")) {
      if (regexS.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const buttonref: any = useRef(null);
  const handleOutsideButton = () => {
    buttonref?.current?.click();
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // handleNextBtnClick(e);
  }


  const overlayInputChange = (e: any) => {
    const enteredValue = e.target.value;
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1Overlay === ("Device Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }
  }

  var dropdownData = [
    { key: "op_1", label: <Body1 onClick={() => { setSelectedValue(1); setSelectedTableData([]) }}> Choose devices manually </Body1> },
    { key: "op_2", label: <Body1 onClick={() => setSelectedValue(2)}> Upload a CSV containing the Devices </Body1> }
  ];
  var overlayColumns = [
    { key: "device_name", label: <Caption1> Device Name</Caption1> },
    { key: "os", label: <Caption1> Operating System  </Caption1> },
  ];

  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Devices?.Overview.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "installation_date_timezoned" || val.key === "last_event_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Devices?.Overview.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Devices", page: "Overview" });
  }, [contextValue.tableColumnsData]);

  //data table column name code starts here
  var statusColumn = [
    { key: "offline", label: <Caption1> Offline </Caption1> },
    { key: "online", label: <Caption1> Online </Caption1> },
  ]
  // var columns = [
  //   { key: "device_name", label: <Body1Strong> Device Name </Body1Strong>  },
  //   { key: "manufacturer", label: <Body1Strong> Manufacturer </Body1Strong> },
  //   { key: "os", label: <Body1Strong> Operating System </Body1Strong> },
  //   { key: "installation_date", label: <Body1Strong> Installation Date (UTC)</Body1Strong> },
  //   { key: "installation_date_timezoned", label: <Body1Strong> Installation Date ({formattedTimeZone})</Body1Strong> },
  //   { key: "nanoheal_version", label: <Body1Strong> Nanoheal Version </Body1Strong> },
  //   { key: "last_event", label: <Body1Strong> Latest Event (UTC)</Body1Strong> },
  //   { key: "last_event_timezoned", label: <Body1Strong> Latest Event ({formattedTimeZone})</Body1Strong> },
  //   { key: "compliance_status", label: <Body1Strong> Compliance Status </Body1Strong> },
  // ];
  // var columns1 = [
  //   { key: "device_name", label: <Caption1> Device Name </Caption1>  },
  //   // { key: "manufacturer", label: <Caption1> Manufacturer </Caption1> },
  //   { key: "os", label: <Caption1> Operating System </Caption1> },
  //   { key: "nanoheal_version", label: <Caption1> Nanoheal Version </Caption1> },
  //   // { key: "online_status", label: <Caption1> Online Status </Caption1> },
  //   { key: "last_checkin_hours", label: <Caption1> Last Check-in in 24 Hours </Caption1> },
  //   { key: "last_checkin_week", label: <Caption1> Last Check-in in 1 Week </Caption1> },
  //   { key: "installation_date", label: <Caption1> Installation Date </Caption1> },
  // ];
  //data table column name code ends here
  const [isIconEnabled, setIconEnabled] = useState(false);
  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          {permissions.includes("overview_Read") || permissions.includes("overview_ReadandExport") ? (
            <TooltipHost content="You do not have access">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <TrayItemRemove20Filled {...secondaryIcon} /> </StackItem>
                  <StackItem> <Caption1> Expunge </Caption1> </StackItem>
                </Stack>
              </Button>
            </TooltipHost>
          ) : permissions.includes("all") || permissions.includes("overview_Fullaccess") ? (
            <Button shape="circular" disabled={loading ? true : false} appearance="subtle" size="small" onClick={() => {
              setOverlayType("default");
              setOverlayOpen(true);
              setChecked({ expungeAsset: true, expungeEvent: true, expungePatch: true })
              setSelectedValue(0);
              // contextValue.setSelectedRowIdInSubTable([]);
              // setDevicesOfTenant(null);
              setCsvDevicesList([]);
            }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> {loading ? <TrayItemRemove20Filled {...secondaryIcon} /> : <TrayItemRemove20Filled {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Expunge </Caption1> </StackItem>
              </Stack>
            </Button>
          ) :
            <StackItem>
              <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <TrayItemRemove20Filled {...secondaryIcon} /> </StackItem>
                        <StackItem><Caption1> Expunge </Caption1></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
            </StackItem>
          }

        </StackItem>
        <StackItem>
          {/* <Divider vertical></Divider> */}
        </StackItem>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        {/* here is export */}
        <StackItem>
          {
            permissions.includes("all") || permissions.includes("overview_Fullaccess") || permissions.includes("overview_ReadandExport") ? (
              <StackItem>
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_overview_${dateFormat()}.csv`}>
                </CSVLink>
                {/* <Button shape="circular"  appearance="subtle" size="small" onClick={() => {setExportBtnClicked(true);}}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>{loading?<ArrowDownload20Regular {...secondaryIcon} />:<ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button> */}
                <DynamicDialog
                  headerButton={
                    <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small">
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> {loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                      </Stack>
                    </Button>
                  }
                  content={dialogContentBody()}
                  position='end'
                  modalType='modal'
                  footer={
                    <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 15 }} >
                      <StackItem > <Button shape="circular" size="small" appearance="primary" disabled={exportOpen ? false : true} onClick={exportReportHandler}> Download </Button> </StackItem>
                      <StackItem> <Button shape="circular" size="small"> Cancel </Button> </StackItem>
                    </Stack>
                  }
                />
              </StackItem>

            ) :
              <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                        <StackItem><Caption1> Export </Caption1></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
          }
        </StackItem>

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setOverlayOpen(true); setOverlayType("version"); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}  </StackItem>
              <StackItem> <Caption1> Nanoheal client update </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem>
          <Button disabled={loading ? true : false} appearance="subtle" size="small" onClick={() => { setOverlayOpen(true); setOverlayType("config"); contextValue.setDartNo(0) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}  </StackItem>
              <StackItem> <Caption1> Nanoheal client config </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  var tempTableData: any = [];
  var tempTableData1: any = [];
  var menuLists: any = [];

  // useEffect(() => {
  //   exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  // }, [exportData]);


  useEffect(() => {

    if (final_data !== undefined && final_data !== null) {
      const newUniqueOs: any = [];
      const newUniqueVersion: any = [];

      final_data.forEach((val: any) => {
        // Ensure the OS name is valid and not already in the list
        if (val.os && val.os.trim() !== "-" && !newUniqueOs.includes(val.os)) {
          newUniqueOs.push(val.os);
        }
        if (val.clientversion && val.clientversion.trim() !== "-" && !newUniqueVersion.includes(val.clientversion)) {
          newUniqueVersion.push(val.clientversion);
        }
      });

      setUniqueOS(newUniqueOs);
      setUniqueVersion(newUniqueVersion);
    } else {
      setUniqueOS([]);
      setUniqueVersion([]);

    }
  }, [final_data]);


  useEffect(() => {
    // data table values append code starts here

    const onlineDevices = [];
    const offlineDevices = [];

    Object.keys(machineStatus).forEach((val) => {

      machineStatus[val][0] === "online" ? onlineDevices.push(val) : offlineDevices.push(val);
    });

    onlineDevices.length > 0 && setOnlineDevices(onlineDevices);
    offlineDevices.length > 0 && setOfflineDevices(offlineDevices);

    !isOverlayFilter && final_data !== undefined && final_data !== null
      ? final_data?.map((val: any, i: any) => {
        const operatingSystem = val.os;
        const Operating_System = operatingSystem?.substring(0, 9) + "\n" + operatingSystem?.substring(9, 21) + "\n" + operatingSystem?.substring(21);
        var deviceStatus: any = Object.keys(machineStatus)?.length > 0 && machineStatus[`${val.host}`]?.length > 0 ? machineStatus[`${val.host}`][0] : 'offline';
        var deviceType: any = Object.keys(machineStatus)?.length > 0 && machineStatus[`${val.host}`]?.length > 0 ? machineStatus[`${val.host}`][1] : 'default';
        var currentIcon = <Badge size="extra-small" appearance="filled" color={deviceStatus === 'online' ? "success" : "informative"} > </Badge>;

        if (deviceStatus === 'online') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/G_Win.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/G_Android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/G_Apple.svg" alt="Analyze Icon" />;
          }
        } else if (deviceStatus === 'offline') {
          if (deviceType == 1) {
            currentIcon = <Image src="/Dashboard/image/Windows.svg" alt="Analyze Icon" />;
          } else if (deviceType == 2) {
            currentIcon = <Image src="/Dashboard/image/android.svg" alt="Analyze Icon" />;
          } else if (deviceType == 5) {
            currentIcon = <Image src="/Dashboard/image/apple.svg" alt="Analyze Icon" />;
          }
        }

        tempTableData.push({
          checkbox: 'hide',
          device_name: { label: <Caption1> {val.host} </Caption1>, icon: currentIcon, id: `${i}` },
          manufacturer: { label: <Caption1>&nbsp;&nbsp; {val.value != null && val.value?.length > 0 ? JSON.parse(val.value).chassismanufacturer : "-"} </Caption1>, status: "" },
          chassistype: { label: <Caption1>&nbsp;&nbsp; {val.value != null && val.value?.length > 0 ? JSON.parse(val.value).chassistype : "-"} </Caption1>, status: "" },
          os: { label: <Caption1> {Operating_System != "undefined\nundefined\nundefined" ? Operating_System : "-"} </Caption1> },
          osversion: { label: <Caption1> {val.clientversion} </Caption1> },
          nanoheal_version: { label: <Caption1> {val.clientversion} </Caption1>, },
          installation_date: { label: <Caption1> {convertUTCToReadableFormat(val.born)} </Caption1> },
          installation_date_timezoned: { label: <Caption1> {convertToLocalTimezone(val.born, userTimeZone)} </Caption1> },
          last_event: { label: <Caption1> {convertUTCToReadableFormat(val.last)} </Caption1>, },
          last_event_timezoned: { label: <Caption1> {convertToLocalTimezone(val.last, userTimeZone)} </Caption1> },
          compliance_status: { label: <Link style={buttonContent} onClick={() => { /*localStorage.setItem('automationDetails', JSON.stringify({ automationName: val.automationName, automationType: val.types })); contextValue.setDartNo(val.dartid);*/ contextValue.setAutomationDetails({ ...contextValue.automationDetails, automationName: val.host }); navigate("/manage/devices/compliance_status") }}> Status </Link >, id: `${i}` },
        });
      }) : (tempTableData = []);

    !isOverlayFilter && (tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]));

    setTimeout(() => {
      !isOverlayFilter && final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, machineStatus, permissions]);
  useEffect(() => {
    if (dropDownValue1 === 'Last Check-in in 1 Week') {
      const currentTimestamp = new Date();
      const sevenDaysAgo = new Date(currentTimestamp);
      sevenDaysAgo.setDate(currentTimestamp.getDate() - 7); // Subtract 7 days

      const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(sevenDaysAgo);

      setDropDownValue2(formattedDate); // Automatically set the formatted date
    }

    if (dropDownValue1 === 'Last Check-in in 24 Hours') {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1); // Subtract 1 day

      const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(yesterday);

      setDropDownValue2(formattedDate); // Automatically set the formatted date
    }
  }, [dropDownValue1]);

  // useEffect(() => {
  //   if (dartTemplatesList?.length > 0) {
  //     setIsDisabled(false);
  //   } else {
  //     setIsDisabled(true);
  //   }
  // }, [dartTemplatesList])

  const handleNewFormChange1 = (e: any) => {
    setFormData1({
      ...formData1,
      jsonData: e.formData
    });
  }

  const handleNewFormChange2 = (e: any) => {
    setFormData2({
      ...formData2,
      jsonData: e.formData
    });
  }

  useEffect(() => {
    var defaultSelected: any = [];
    if (overlayType === "default") {
      setOverLayData({
        size: "large",
        isTabs: false,

        headerTitle:
          (
            <>
              <FluentProvider theme={dashboardTheme}>
                <Title3> Expunge </Title3>
              </FluentProvider>
            </>
          ),

        tabItems: {},

        bodyData:
          (
            <>
              <FluentProvider theme={dashboardTheme}>
                <Stack horizontal enableScopedSelectors>
                  <StackItem grow={4}>
                    <Stack tokens={{ childrenGap: 20 }}>
                      <StackItem>
                        <Body1>How would you like to expunge the data? </Body1>
                      </StackItem>
                      <StackItem>
                        <DropdownComponent optionData={dropdownData} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                        {(selectedValue === 1 || selectedValue === 2) &&
                          <Stack horizontal tokens={{ childrenGap: 1 }}>
                            <StackItem>
                              <CheckBox name="expungeAsset" checked={isChecked.expungeAsset} onChange={(e: any) => { handleCheckboxChange(e) }} label={<Caption1>Expunge Asset</Caption1>}></CheckBox>
                            </StackItem>
                            <StackItem>
                              <CheckBox name="expungeEvent" checked={isChecked.expungeEvent} onChange={(e: any) => { handleCheckboxChange(e) }} label={<Caption1>Expunge Event</Caption1>}></CheckBox>
                            </StackItem>
                            <StackItem>
                              <CheckBox name="expungePatch" checked={isChecked.expungePatch} onChange={(e: any) => { handleCheckboxChange(e) }} label={<Caption1>Expunge Patch</Caption1>}></CheckBox>
                            </StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem><Text></Text></StackItem>
                            <StackItem>
                              <InfoLabel size="large" info="Here you can select the what things you want to expunge"></InfoLabel>
                            </StackItem>
                          </Stack>}
                      </StackItem>

                      <StackItem>
                        {selectedValue === 1 &&
                          <>
                            <FluentProvider theme={dashboardTheme}>
                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 10 }}>
                                    <InfoBar title={"Try changing or adding filters if you don't see what you're looking for."} />
                                    <StackItem>
                                      <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                                        <SearchBar columnSearch={"for Device Name"} searchVal={searchVal} setSearchVal={setSearchVal} disabled={loading || devicesTableData.length===0 } />
                                        <StackItem>
                                          <MenuDropdown open={filterMenuOpenOverlay} btn={
                                            <MenuButton disabled={loading || devicesTableData.length===0 } shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <FilterAdd20Filled {...primaryIcon} />
                                                <Body1> Filter </Body1>
                                              </Stack>
                                            </MenuButton>
                                          } itemVal={
                                            <>
                                              <Body1Strong> Add a Filter </Body1Strong>
                                              <Divider />
                                              <MenuList>
                                                <Stack tokens={{ childrenGap: 5 }}>
                                                  <StackItem> <Text></Text> </StackItem>
                                                  <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                  <DropdownComponent optionData={overlayColumns} setDropDownValue={setDropDownValue1Overlay} dropDownvalue={dropDownValue1Overlay} />
                                                  <StackItem> <Divider /> </StackItem>
                                                  <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                  {dropDownValue1Overlay === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />}
                                                  {dropDownValue1Overlay === "Device Name" && <Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />}
                                                  <StackItem>
                                                    <Divider />
                                                  </StackItem>
                                                  <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                    <StackItem>
                                                      <Button shape="circular" appearance="primary" onClick={() => { handleOverlayFilter(); setFilterMenuOpenOverlay(false) }}
                                                        disabled={dropDownValue2Overlay == undefined || dropDownValue2Overlay?.length === 0 || dropDownValue1Overlay == undefined || dropDownValue1Overlay?.length === 0 || filterArray.includes(`${dropDownValue1Overlay}:`) ? true : false}>
                                                        <Caption1> Apply </Caption1>
                                                      </Button>
                                                    </StackItem>
                                                    <StackItem>
                                                      <Button shape="circular" onClick={() => setFilterMenuOpenOverlay(false)}>     <Caption1> Cancel </Caption1>
                                                      </Button>
                                                    </StackItem>
                                                  </Stack>
                                                </Stack>
                                              </MenuList>
                                            </>}
                                          />
                                        </StackItem>
                                        <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true) }}>
                                          <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                              <StackItem> <FilterDismiss20Filled /> </StackItem>
                                              <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                            </Stack>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </StackItem>
                                    <StackItem>
                                      {filterArray.length > 0 && filterArray.map((item, index) => (
                                        <Button shape="circular" size="small">
                                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> {item} </StackItem>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 1 }}>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                              </Stack>
                                            </StackItem>
                                          </Stack>
                                        </Button>
                                      ))}
                                    </StackItem>
                                    <StackItem>
                                      {(devicesTableData.length > 0) && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                                        <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                                        <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>
                                      </Stack>}
                                      <Stack tokens={{ childrenGap: 10 }}>
                                        <FluentProvider theme={dashboardTheme}>
                                          {devicesTableData.length > 0 ? (<DataTable tableData={devicesTableData} columns={overlayColumns} isSubTable={true} defaultSelected={defaultSelected} />) : <Stack>
                                            <StackItem>
                                              <Caption1> No new devices found.</Caption1>
                                            </StackItem>
                                          </Stack>}
                                        </FluentProvider>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>
                            </FluentProvider>
                          </>}

                        {selectedValue === 2 &&
                          <>
                            <Stack tokens={{ childrenGap: 15 }}>
                              <StackItem><Text></Text></StackItem>
                              <StackItem> <Body1Strong> Steps to create the CSV group </Body1Strong> </StackItem>
                              <StackItem> <Body1> 1. Download the file that contains the list of devices </Body1> </StackItem>
                              <Stack tokens={{ childrenGap: 10 }} horizontal>
                                <StackItem><Text></Text></StackItem>
                                <StackItem><FileDownloadComponent data={"Machines\n" + final_data.map((val: any) => `${val.id}-${val.host}`).join("\n")
                                } fileName={tenantName + `_devices_list`} /> </StackItem>
                              </Stack>
                              <Stack>
                                <StackItem> <Body1> 2. Revise device grouping in the CSV. </Body1> </StackItem>
                                <StackItem>
                                  <Stack tokens={{ childrenGap: 15 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <Caption1> Watch the instructional video for guidance </Caption1> </StackItem>
                                        <StackItem> <Open20Regular /> </StackItem>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </StackItem>
                              </Stack>

                              <StackItem> <Body1> 3. Upload your .csv file </Body1> </StackItem>
                              <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <StackItem><Text></Text></StackItem>
                                <StackItem>
                                  {/* <DropdownComponent optionData={ddData} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1}/> */}
                                  <FileUploadComponent setDeviceList={setCsvDevicesList} />
                                </StackItem>
                              </Stack>

                              {devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length > 0 && <><StackItem><Text>{selectedTableData.length} machines found.</Text> </StackItem>
                                <StackItem><Text>Kindly check the group names and confirm that everything is exactly the way you need them. If you have made any mistake,Kindly make the changes and upload the CSV with the corrections</Text></StackItem></>}

                              {devicesOfTenant != null && csvDevicesList.length > 0 && selectedTableData.length == 0 && <StackItem><Text>No machine found</Text></StackItem>}
                            </Stack>
                          </>
                        }
                      </StackItem>
                    </Stack>
                  </StackItem>

                  {selectedValue === 1 &&
                    <>
                      <Divider vertical />
                      <StackItem grow={1}>
                        {(contextValue.selectedRowIdInSubTable.length >= 0 || selectedTableData.length >= 0) && <StackItem>
                          <Stack horizontal>
                            {/* <Label> <Body1Strong> Selected </Body1Strong> </Label> */}
                            <StackItem>
                              <DataTable tableData={selectedTableData} columns={[{ key: "selected", label: <Body1Strong> Selected ({contextValue.selectedRowIdInSubTable.length})<Button shape="circular" appearance="transparent" size="small" onClick={() => contextValue.setSelectedRowIdInSubTable([])}>Reset</Button></Body1Strong> }]} />
                            </StackItem>
                          </Stack>
                        </StackItem>}
                      </StackItem>
                    </>

                  }

                </Stack>
              </FluentProvider>
              {/* THIS SHOULD BE FETCHED FROM THE BACKEND */}
            </>
          ),

        footerData:
          (
            <>
              <DialogBox
                headerButton={
                  <>
                    {selectedValue == 1 ? <Button shape="circular" appearance="primary" size="small" onClickCapture={() => setCurrentPageNo(1)}
                      disabled={(contextValue.selectedRowIdInSubTable?.length > 0) ? false : true}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <Caption1> Submit  </Caption1> </StackItem>
                      </Stack>
                    </Button> : <Button shape="circular" appearance="primary" size="small" onClickCapture={() => setCurrentPageNo(1)}
                      disabled={(csvDevicesList != "" && selectedTableData.length > 0) ? false : true}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <Caption1> Submit  </Caption1> </StackItem>
                      </Stack>
                    </Button>}
                  </>
                }

                content={`Are you sure you want to expunge ${contextValue.selectedRowIdInSubTable
                  .length} ${contextValue.selectedRowIdInSubTable
                    .length > 1 ? 'devices' : 'device'}?`}

                footer=
                {
                  <>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <Button shape="circular" appearance="primary" size="small" onClick={() => { setIsExpungeMachineData(true); setOverlayOpen(false); setExpungeType(selectedValue == 1 ? 'manual' : 'csv') }}>Confirm</Button>
                      </StackItem>
                      <StackItem>
                        <Button shape="circular" size="small" >Cancel</Button>
                      </StackItem>
                    </Stack>
                  </>
                }
              />
            </>
          )
      });
    } else if (overlayType === "version") {
      setOverLayData({
        size: "large",
        isTabs: false,

        headerTitle:
          (
            <>
              <FluentProvider theme={dashboardTheme}>
                <Title3> Nanoheal Client Update </Title3>
              </FluentProvider>
            </>
          ),

        tabItems: {},

        bodyData:
          (
            <>
              <Stack tokens={{ childrenGap: 40 }} grow>
                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem><Body1Strong>Select the operating system where you want to update to the latest version</Body1Strong></StackItem>
                  <DropdownComponent />
                </Stack>
                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem><Body1Strong>Benefits available in the version</Body1Strong></StackItem>
                  <Textarea />
                </Stack>
              </Stack>
            </>
          ),
        footerData:
          (
            <>
              <DialogBox
                headerButton={
                  <>
                    <Button shape="circular" size="small" appearance="primary">Update</Button>
                  </>
                }
                content="Are you sure you want to update the Nanoheal client to teh latest version on the selected device?"
                footer={
                  <>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <Button shape="circular" appearance="primary" size="small" onClick={() => { setOverlayOpen(false); }}>Confirm</Button>
                      </StackItem>
                      <StackItem>
                        <Button shape="circular" size="small" >Cancel</Button>
                      </StackItem>
                    </Stack>
                  </>
                }
              />
              <DialogBox
                headerButton={
                  <>
                    <Button shape="circular" size="small" appearance="primary">Clear updates</Button>
                  </>
                }
                content="Are you sure you want to clear the version for selected device?"
                footer={
                  <>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <Button shape="circular" appearance="primary" size="small" onClick={() => { setOverlayOpen(false); }}>Confirm</Button>
                      </StackItem>
                      <StackItem>
                        <Button shape="circular" size="small" >Cancel</Button>
                      </StackItem>
                    </Stack>
                  </>
                }
              />
            </>
          ),
      })
    } else if (overlayType === "config") {
      setOverLayData({
        size: "large",
        isTabs: true,
        headerTitle:
          (
            <>
              <FluentProvider theme={webLightTheme}>
                <Title3> Nanoheal Client Config </Title3>
              </FluentProvider>
            </>
          ),

        tabItems: {
          "System Asset Details": <Stack style={parentHome} tokens={{ childrenGap: 15, padding: '10px 0' }}>
            <StackItem style={parentHome} >
              {!isDisabled ?
                <Form autoComplete="off" id="configForm" ref={formRef} formData={formData1.jsonData} schema={jsonSchema?.schema1} uiSchema={uiSchema?.schema1} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange1(e)} />
                : <Stack verticalAlign="center" style={oveyAlignment}>
                  <Spinner />
                </Stack>}
            </StackItem>
          </Stack>,
          "Customer Contact Information": <Stack tokens={{ childrenGap: 15, padding: '10px 0' }}>
            <StackItem >
              {!isDisabled ?
                <Form autoComplete="off" id="configForm" ref={formRef} formData={formData2.jsonData} schema={jsonSchema?.schema2} uiSchema={uiSchema?.schema2} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange2(e)} />
                : <Stack verticalAlign="center" style={oveyAlignment}>
                  <Spinner />
                </Stack>}
            </StackItem>
          </Stack>,
          'Review Data': <Stack tokens={{ childrenGap: 15, padding: '10px 0' }}>
                <Subtitle2>System Asset Details:</Subtitle2>
              <StackItem className="BoxTheme">
                <Form autoComplete="off" id="configForm" formData={formData1.jsonData} schema={jsonSchema?.schema1} uiSchema={uiSchema?.schema1} validator={validator} widgets={CustomWidgets} disabled />
              </StackItem>
                  <Subtitle2>Customer Contact Information:</Subtitle2>
                <StackItem className="BoxTheme">
                  <Form autoComplete="off" id="configForm" formData={formData2.jsonData} schema={jsonSchema?.schema2} uiSchema={uiSchema?.schema2} validator={validator} widgets={CustomWidgets} disabled />
                </StackItem>
              </Stack>
        },

        bodyData:
          (
            <>
              <Stack tokens={{ childrenGap: 40 }} grow>

              </Stack>
            </>
          ),
        footerData:
          (
            <>
            </>
          ),
      })
    }
  }, [overlayType, devicesTableData, formData1, formData2, isDisabled, jsonSchema, selectedValue, selectedTableData, isChecked, dropDownValue1Overlay, dropDownValue2Overlay, filterMenuOpenOverlay, filterArray, isfilter]);

  var validDevicesList: any = [];
  var inValidDevicesList: any = [];
  var alldDevicesList: any = [];

  useEffect(() => {
    if (csvDevicesList.length > 0) {
      validDevicesList = [];
      inValidDevicesList = [];
      alldDevicesList = [];
      devicesOfTenant?.map((val: any) => {
        alldDevicesList.push(val.host);
      });

      csvDevicesList.map((val: any) => {

        var deviceName = val.replace(/[\r\n]/g, '').trim();
        var deviceNameWithCensusId = val.replace(/[\r\n]/g, '').trim().split("-");
        var first_part = deviceNameWithCensusId[0];
        var second_part = deviceNameWithCensusId.slice(1).join("-")
        alldDevicesList.includes(second_part) ? validDevicesList.push(deviceName) : inValidDevicesList.push(deviceName);
      });

      validDevicesList.length > 0 ? setSelectedTableData(validDevicesList) : setSelectedTableData([]);

      contextValue.setSelectedRowIdInSubTable(validDevicesList);
    }
  }, [devicesOfTenant, csvDevicesList, exportDetails]);

  useEffect(() => {
    if (!overlayOpen) {
      setFilterArray([]);
      setSelectedValue(0);
      setDropDownValue('');
      setJsonData({schema1:{},schema2:{}});
      setUiData({schema1:{},schema2:{}});
      setFormData1({ jsonData: '' });
      setFormData2({ jsonData: '' });
      setOverlayType("default");
      searchVal.length > 0 && setSearchVal("");
    }
    contextValue.setSelectedRowIdInSubTable([]);
  }, [overlayOpen, dropDownValue]);

  useEffect(() => {
    !deleteDevices && contextValue.setSelectedRowIdInTable([]);
    !deleteDevices && contextValue.setSelectedRowIdInSubTable([]);
  }, [deleteDevices]);

  useEffect(() => {
    // devices data table values append code starts here
    final_data !== undefined && final_data !== null
      ? final_data?.map((val: any, i: any) => {
        if (!(selectedDevices.includes(val.host)) && !(contextValue.selectedRowIdInSubTable.includes(val.host))) {
          tempTableData1.push({
            id: `${val.id}-${val.host}`,
            device_name: { label: <Caption1> {val.host} </Caption1>, id: `${i}` },
            os: { label: <Caption1> {val.os} </Caption1>, status: "" },
          });
        }
      }) : (tempTableData1 = []);

    tempTableData1.length > 0 ? setDevicesTableData(tempTableData1) : setDevicesTableData([]);
  }, [final_data, selectedDevices]);

  useEffect(() => {
    var newSelectedValues = selectedDevices.concat(contextValue.selectedRowIdInSubTable)
    const uniqueSet = new Set(newSelectedValues);
    const resultArray = Array.from(uniqueSet);

    contextValue.setSelectedRowIdInSubTable(resultArray);
  }, [selectedDevices]);

  var dataArr: any = [];
  useEffect(() => {
    contextValue.selectedRowIdInSubTable.map((val: any, i: any) => {
      dataArr.push({
        id: i,
        checkbox: "hide",
        selected: { label: <Caption1> {val.split("-").slice(1).join("-")} </Caption1>, id: `${i}` },
      });
    });

    dataArr.length > 0 ? setSelectedTableData(dataArr) : setSelectedTableData([]);

    contextValue.selectedRowIdInTable.length > 0 ? setIconEnabled(true) : setIconEnabled(false);
  }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                {/* <StackItem grow shrink> <Breadcrumbs pageName="Devices" subPageName="Overview" subPageLink="#" /> </StackItem> */}
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
                      { name: "Manage", link: "/home" },
                      { name: "Devices", link: "#" },
                      { name: "Overview", link: "#" }
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
            {/* <StackItem grow shrink>
              <Stack horizontalAlign="end">
                <StackItem grow shrink>
                  <FullScreenButton handle={handle} />
                </StackItem>
              </Stack>
            </StackItem> */}
          </Stack>
        </StackItem>
        {/* <Divider /> */}
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                <StackItem> <Text></Text> </StackItem>
                <StackItem>
                  <FluentProvider theme={dashboardTheme}>
                    <Title3> Devices | Overview </Title3>
                  </FluentProvider>
                </StackItem>
              </Stack> */}
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  {/* <FluentProvider theme={sidenavTheme} style={parentHome}> */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={DevicesPages("Overview")} />
                  {/* </FluentProvider> */}
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem>
                        <StackItem style={{...wraperStyle, paddingLeft:'10px'}}>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                              {/* <StackItem><Text></Text></StackItem> */}
                              <StackItem>
                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Device Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <FilterAdd20Filled {...secondaryIcon} /> : <FilterAdd20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      {/* <DropdownComponent optionData={columns1} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1} /> */}
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {(dropDownValue1 === 'Installation Date' || dropDownValue1 === 'Last Check-in in 1 Week' || dropDownValue1 === 'Last Check-in in 24 Hours') && (
                                        filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (
                                          <span style={{ color: 'red' }}>This column is already filtered</span>
                                        ) : (
                                          <div>
                                            {dropDownValue1 === 'Last Check-in in 1 Week' && (
                                              <span>From: {dropDownValue2}</span>
                                            )}
                                            {dropDownValue1 === 'Last Check-in in 24 Hours' && (
                                              <span>From: {dropDownValue2}</span>
                                            )}
                                            {dropDownValue1 === 'Installation Date' && (
                                              <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                                            )}
                                          </div>
                                        )
                                      )}
                                      {/* {(dropDownValue1 === 'Installation Date' || dropDownValue1 === 'Last Check-in in 1 Week' || dropDownValue1 === 'Last Check-in in 24 Hours') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))?  ( <span style={{ color: 'red' }}>This column is already filtered</span> ) : (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}                                     */}
                                      {dropDownValue1 === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      {dropDownValue1 === "Nanoheal Version" && <DropdownComponent optionData={versionOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      {dropDownValue1 === "Device Status" && <DropdownComponent optionData={statusColumn} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      {(dropDownValue1 === "Device Name" || dropDownValue1 === "Manufacturer") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>

                              <StackItem onClick={() => { setIsOverlayFilter(false); setFilterArray([]); setIsFilter(false); setDropDownValue2Overlay(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>

                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>

                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 &&
                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                  {/* </Stack> */}
                                </Stack>}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                      </StackItem>

                      <Census_func
                        filterArray={filterArray}
                        data={final_data}
                        func={set_final_data}
                        searchVal={searchVal}
                        pageNo={(currentPageNo - 1) * 50}
                        setTotalPages={setTotalPages}
                        setTotalRecords={setTotalRecords}
                        isFilter={isfilter}
                        setIsFilter={setIsFilter}
                        setExportDetails={setExportDetails}
                        setRefreshToast={setRefreshToast}
                        setIsRefresh={setIsRefresh}
                        refreshToast={refreshToast}
                        isRefresh={isRefresh}
                        setMachineStatus={setMachineStatus}
                        isExpungeMachineData={isExpungeMachineData}
                        setIsExpungeMachineData={setIsExpungeMachineData}
                        isChecked={isChecked}
                        setDevicesOfTenant={setDevicesOfTenant}
                        devicesOfTenant={devicesOfTenant}
                        setExpungeType={setExpungeType}
                        expungeType={expungeType}
                        setToastMessage={setToastMessage}
                        setErrorToast={setErrorToast}
                        setIsToast={setIsToast}
                        setExportBtnClicked={setExportBtnClicked}
                        exportBtnClicked={exportBtnClicked}
                        overlayOpen={overlayOpen}
                        selectedValue={selectedValue}
                        dropdownData={dropdownDatas}
                        saveBtnClicked={saveBtnClicked}
                        setSaveBtnClicked={setSaveBtnClicked}
                        setDartTemplatesList={setDartTemplatesList}
                        setIsDisabled={setIsDisabled}
                        setJsonData={setJsonData}
                        setUiData={setUiData}
                        dartNo={dartNo}
                        dataList={[61, 253]}
                        overlayType={overlayType}
                        formData1={formData1}
                        formData2={formData2}
                        setFormData1={setFormData1}
                        setFormData2={setFormData2}
                        setOverlayOpen={setOverlayOpen}
                        setOverlayType={setOverlayType}
                        operationType={operationType}
                        setOperationType={setOperationType}
                      />

                      {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                      {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={toastMessage} footer="" />}

                      {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              isDisabled={overlayType === 'config' ? isDisabled : false}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayData}
              isNavBtn={overlayType === 'config' ? true : false}
              saveBtnFunc={overlayType === 'config' && setSaveBtnClicked}
              handleOutsideButton={overlayType === 'config' && handleOutsideButton}
              formRef={overlayType === 'config' && formRef}
              handleSubmit={overlayType === 'config' && handleSubmit} />
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};
